/*
 * @Descripttion:
 * @version:
 * @Author: HeYang
 * @Date: 2019-09-18 14:40:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-14 16:01:22
 */
import store from "@/store/index";
import { Toast, Indicator } from "mint-ui";
import { callNativePromise } from "../js/MMCWKEventWeb.js";
import axios from "axios";
import { getPayUrlByOrderId } from "@/service/api.ts";
import wxShare from "./wxShare.js";
import router from "@/router/index";
import queryString from 'query-string';

const ydkPlatform = [32, 33, 69, "32", "33", "69"];

/**
 * @param {String} attr
 * @description 从URL中解析参数，不传attr则返回参数对象
 */
export const getParams = (attr?: any) => {
    let search = decodeURIComponent(location.search);

    if (!search || search == "?") return null;
    search = search.replace("?", "");

    let param_arr = search.split("&"),
        param_map: any = {};
    param_arr.forEach((item) => {
        let _key = item.split("=")[0],
            value = item.split("=")[1];
        param_map[_key] = value;
    });
    if (attr) {
        return param_map[attr];
    }
    return param_map
};

/**
 * 替换URL中的指定参数，如果没有此参数，会自动添加
 * @param {*} originUrl
 * @param {*} name
 * @param {*} val
 */
export const replaceUrlParams = (originUrl: any, name: any, val: any) => {
    let url = originUrl;
    url = url.replace(/\?$/g, '');
    let urlArr = url.split('?');
    if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
        let query = urlArr[1];
        let obj = {};
        let arr = query.split('&');
        for (let i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split('=');
            obj[arr[i][0]] = arr[i][1];
        }
        obj[name] = val;
        let urlte =
            urlArr[0] +
            '?' +
            JSON.stringify(obj)
                .replace(/[\"\{\}]/g, '')
                .replace(/\:/g, '=')
                .replace(/\,/g, '&');
        return urlte;
    } else {
        url += `${url.match(/\?/) ? '&' : '?'}${name}=${val}`;
        return url;
    }
};
/**
 * 删除URL中的指定参数
 * @param {*} url
 * @param {*} name
 */
export const delUrlParams = (url: any, name: any) => {
    let urlArr = url.split('?');
    if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
        let query = urlArr[1];
        let obj = {};
        let arr = query.split('&');
        for (let i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split('=');
            obj[arr[i][0]] = arr[i][1];
        }
        delete obj[name];
        let urlte =
            urlArr[0] +
            '?' +
            JSON.stringify(obj)
                .replace(/[\"\{\}]/g, '')
                .replace(/\:/g, '=')
                .replace(/\,/g, '&');
        urlte = urlte.replace(/\?$/g, '');
        return urlte;
    } else {
        return url;
    }
};


/**
 * @name: 判断图片加载完成
 * @param {type} 图片路径
 * @return: promise
 */
export const preloadImage = (url: string) => {
    //返回一个promise对像
    return new Promise((resolve, reject) => {
        let newImages = new Image();
        //设置图片src属性
        newImages.src = url;
        //图片绑定onload事件，确保加载完成
        newImages.onload = () => {
            //当加载完成后，resolve
            resolve();
        };
        newImages.onerror = () => {
            reject();
        };
    });
};

// 判断是否是测试环境
export const isSandbox = () => {
    return process.env.VUE_APP_MODEL !== "production";
    // let host = location.host;
    // return /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(host) || /localhost/i.test(host) || /sandbox/i.test(host);
};

// 判断设备
export const isIOS = () => {
    let u = navigator.userAgent;
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isIOS;
};

export function isHuawei() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('huawei') > -1;
}

// 判断是否在百度小程序内
export const isSwan = () => {
    let smartprogram = false;
    (window as any).swan.webView.getEnv((res: any) => {
        smartprogram = res.smartprogram;
        console.log('小程序环境', res);
    })
    return smartprogram;
};

// 判断是否微信小程序
export const isWxMiniprogram = () => {
    var u = navigator.userAgent;
    let check: boolean = false;
    try {
        check = !!(
            (u.match(/MicroMessenger/i) && u.match(/miniprogram/i)) ||
            (window as any).__wxjs_environment === "miniprogram"
        );
    } catch (err) {
        console.log(`isWxMiniprogram_err: `, err);
    }
    return check;
};

// 页面跳转，小程序环境调用小程序跳转，其他环境调路由跳转 type: navigateTo|redirectTo
export const JumpPage = (path: string, bool?: boolean, type = "navigateTo") => {
    if (isWxMiniprogram()) {
        let url = path;
        if (bool) {
            url = `/pagesA/webview/webview?url=${location.origin}/live${path}`;
        }
        (window as any).wx.miniProgram[type]({
            url: url,
        });
    } else {
        router.push({
            path: path,
        });
    }
};

// 判断是否iPad
export const isIpad = () => {
    let u = navigator.userAgent;
    let isIpad = !!u.match(/(?:iPad|PlayBook)/);
    return isIpad;
};

export const isSafari = () => {
    let u = navigator.userAgent;
    return /Safari/.test(u) && !/Chrome/.test(u);
};

// 判断是否微信
export const isWechat = () => {
    return /MicroMessenger/i.test(navigator.userAgent);
};

// 判断是否微博
export const isWeibo = () => {
    return /WeiBo/i.test(navigator.userAgent);
};

//是否为移动终端
export const isMobile = () => {
    return !!(navigator.userAgent.match(/AppleWebKit.*Mobile.*/));
};

// 判断是否iPhone X等机型
export const isIphonex = () => {
    // X XS, XS Max, XR
    const xSeriesConfig = [
        {
            devicePixelRatio: 3,
            width: 375,
            height: 812,
        },
        {
            devicePixelRatio: 3,
            width: 414,
            height: 896,
        },
        {
            devicePixelRatio: 2,
            width: 414,
            height: 896,
        },
    ];
    if (typeof window !== "undefined" && window) {
        if (!isIOS()) return false;
        const { devicePixelRatio, screen } = window;
        const { width, height } = screen;
        return xSeriesConfig.some(
            (item) =>
                item.devicePixelRatio === devicePixelRatio &&
                item.width === width &&
                item.height === height
        );
    }
    return false;
};

/**
 * @name: 设置页面标题
 * @param {type} 标题内容
 * @return:
 */
export function setPageTitle(title: string) {
    if (isIOS() && isWechat()) {
        setTimeout(() => {
            document.title = title;
            const iframe = document.createElement("iframe");
            iframe.style.visibility = "hidden";
            iframe.style.width = "1px";
            iframe.style.height = "1px";
            iframe.src = "/static/favicon.ico";
            iframe.onload = () => {
                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 0);
            };
            document.body.appendChild(iframe);
        }, 0);
    } else {
        document.title = title;
    }
}

export function isLjds() {
    if ((window as any).mmc.client.isAPP()) {
        // 添加iOS易大咖（iOS易大咖添加用户端功能）
        return (window as any).mmc.client.is("ljds") || (isYdk() && isIOS());
    }
    return false;
}

export function isYdkApp() {
    if ((window as any).mmc.client.isAPP()) {
        return (window as any).mmc.client.is("ydk");
    }
    return false;
}

export function isYdk() {
    if (isYdkApp()) {
        return true;
    }

    // 目的用来判断是否知屿达人小程序内
    const platform = localStorage.getItem("platform") || "";
    if (ydkPlatform.includes(platform)) {
        return true;
    }
    return false;
}

export function isTz() {
    if ((window as any).mmc.client.isAPP()) {
        return (window as any).mmc.client.is("tz");
    }
    return false;
}

/**
 * @name: 正式环境添加点击事件埋点
 * @param {
 *  category：要监控的目标的类型名称，通常是同一组目标的名字，比如"视频"、"音乐"、"软件"、"游戏"等等。该项必选。
 *  action：用户跟目标交互的行为，如"播放"、"暂停"、"下载"等等。该项必选。
 *  opt_label：事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项可选。
 *  opt_value：事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选。
 * }
 * @return:
 */
export function addTrackEvent(
    category = "category",
    action = "",
    opt_label = "",
    opt_valu = ""
) {
    try {
        if (!isSandbox()) {
            (window as any)._hmt.push([
                "_trackEvent",
                category,
                action,
                opt_label,
                opt_valu,
            ]);
        }
    } catch (error) {
        console.log(error);
    }
}

// 判断是否在APP内
export function isInApp() {
    return isLjds() || isYdkApp() || isTz();
}

// 判断是否在灵机大师APP内并且登录
export function isApp(needDownload: Boolean = true) {
    return new Promise((resolve, reject) => {
        let { token } = store.state.login;
        if (!token) {
            token =
                getParams("token") ||
                localStorage.getItem("token") ||
                localStorage.getItem("tToken") ||
                "";
        }
        console.log(token, "token===");
        // 判断是否在灵机大师APP内
        if (!isLjds() && !isYdk() && !isTz() && needDownload) {
            location.href = "/live/download";
            reject();
        }
        // console.log(token);
        // 判断是否登录
        if ((!token && isLjds()) || (!token && isYdk()) || (!token && isTz())) {
            (window as any).mmc.init();
            let tryCount = 0;
            const fun = () => {
                tryCount++;
                let { token } = store.state.login;
                if (!token) {
                    callNativePromise("getUserInfo", {}, "cb_getUserInfo").then(
                        (userInfo: any) => {
                            console.log("isApp_userInfo", userInfo);
                            let {
                                token,
                                platform,
                                deviceid,
                                channel,
                                userid,
                                version,
                            } = userInfo;
                            if (token && platform) {
                                localStorage.setItem("platform", platform);
                                axios.defaults.headers["Authorization"] = token;
                                axios.defaults.headers["YQW-Token"] = token;
                                axios.defaults.headers["platform"] = platform;
                                axios.defaults.headers["platformid"] = platform;
                                axios.defaults.headers["DeviceId"] = deviceid;
                                axios.defaults.headers["Publisher-Id"] = 4;
                                axios.defaults.headers["channel"] = channel;
                                axios.defaults.headers["version"] = version;
                                store.commit("login/UPDATE_TOKEN", token);
                                store.commit("login/UPDATE_PLATFORM", platform);
                                store.commit("login/UPDATE_DEVICEID", deviceid);
                                store.commit("login/UPDATE_APPCHANNEL", channel);
                                store.commit("login/UPDATE_USERID", userid);
                                store.commit("login/UPDATE_VERSION", version);
                                resolve();
                            }
                        }
                    );
                    console.log(`尝试`, tryCount);
                    if (tryCount < 30) {
                        return setTimeout(() => {
                            return fun();
                        }, 100);
                    } else {
                        (window as any)._MMCTryCount = 30;
                        console.log(`_MMCTryCount`, 30);
                    }
                }

            };
            setTimeout(() => {
                fun();
            }, 100);
        } else {
            resolve();
        }
    });
}

export function urlParamsObj() {
    var search =
        location.href.split("?")[1] &&
        location.href.split("?")[1].split("#")[0];
    if (!search) {
        return {};
    }
    var params = search.split("&");
    return params.reduce(function(res: any, items) {
        var parts = items.split("=");
        res[parts[0]] = parts[1] + "";
        return res;
    }, {});
}

// 返回页面URL参数（去除token后）
export function delUrlToken() {
    let searchObj = urlParamsObj();
    let keys = Object.keys(searchObj);
    let searchStr = "";
    keys.length &&
        keys.forEach((key) => {
            if (key !== "token") {
                searchStr += `${key}=${searchObj[key]}&`;
            }
        });
    return searchStr.length ? `?${searchStr}` : "";
}

// 节流阀函数
export function throttle(fn: Function, delay: number) {
    var wait = false;
    return function(this: any) {
        var that = this,
            args = arguments;
        if (!wait) {
            wait = true;
            setTimeout(function() {
                fn.apply(that, args);
                wait = false;
            }, delay);
        }
    };
}

export function isNotEmpty(s: any) {
    return !/^\s*$/.test(s);
}
export function isCellPhone(s: any) {
    return /^1[0-9]{10}$/.test(s);
}
// 是否含有Emoji表情包
export function hasEmoji(s: string) {
    return /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi.test(
        s
    );
}
export function isChinese(s: string) {
    return /^[\u4e00-\u9fa5]+$/.test(s);
}

//比较版本号
export function compareVersion(val1: any, val2: any) {
    let arr1 = val1.split(".");
    let arr2 = val2.split(".");
    for (let i = 0; i < arr1.length || i < arr2.length; i++) {
        let r1 = i < arr1.length ? parseInt(arr1[i]) : 0;
        let r2 = i < arr2.length ? parseInt(arr2[i]) : 0;
        if (r1 === r2) continue;
        return r1 > r2 ? true : false; //ture 代表第一个参数大   false代表第二个参数大
    }
    return true; //两个版本相同
}

// 设置某个字段的cookie
export function setCookieItem(
    sKey: string,
    sValue: any,
    vEnd: any,
    sPath: string,
    sDomain: string = "",
    bSecure: boolean = false
) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
        return false;
    }
    let sExpires = "";
    if (vEnd) {
        switch (vEnd.constructor) {
            case Number:
                sExpires =
                    vEnd === Infinity
                        ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT"
                        : "; max-age=" + vEnd;
                break;
            case String:
                sExpires = "; expires=" + vEnd;
                break;
            case Date:
                sExpires = "; expires=" + vEnd.toUTCString();
                break;
        }
    }
    document.cookie =
        encodeURIComponent(sKey) +
        "=" +
        encodeURIComponent(sValue) +
        sExpires +
        (sDomain ? "; domain=" + sDomain : "") +
        (sPath ? "; path=" + sPath : "") +
        (bSecure ? "; secure" : "");
    return true;
}

// iPhone底部刘海判断
export function isIphoneX() {
    let isIphone = /iphone/gi.test(window.navigator.userAgent);
    let windowW = window.screen.width;
    let windowH = window.screen.height;
    let pixelRatio = window.devicePixelRatio;

    let isIPhoneX =
        isIphone &&
        pixelRatio &&
        pixelRatio === 3 &&
        windowW === 375 &&
        windowH === 812;
    let isIPhoneXSMax =
        isIphone &&
        pixelRatio &&
        pixelRatio === 3 &&
        windowW === 414 &&
        windowH === 896;
    let isIPhoneXR =
        isIphone &&
        pixelRatio &&
        pixelRatio === 2 &&
        windowW === 414 &&
        windowH === 896;

    return isIPhoneX || isIPhoneXSMax || isIPhoneXR;
}

// 页面返回上一页
export function pageReturn() {
    if (isLjds() || isYdk()) {
        (window as any).mmc.client.goto(
            {
                params: {
                    action: 110,
                    actioncontent: {
                        global_type: "",
                        func_type: "",
                        data: {},
                    },
                    closeWindow: true,
                },
            },
            () => {}
        );
    } else {
        window.history.go(-1);
    }
}

export function getWechatYqwHost(): String {
    if (isSandbox()) {
        return "https://sandbox-m.yiqiwen.cn";
    } else {
        return "https://m.yiqiwen.cn";
    }
}

// 跳转APP配置
let appConfig = {
    closeWindow: false,
    needRefresh: false,
    needCallback: false,
};
// 跳转客户端
export function goAppModule(
    global_type: string = "",
    func_type: string = "",
    data: any = {},
    callBack: Function = () => {},
    config: any = {}
) {
    if (!isLjds()) {
        return;
    }

    let { closeWindow, needRefresh, needCallback } = Object.assign(
        appConfig,
        config
    );

    (window as any).mmc.client.goto(
        {
            params: {
                action: 110,
                actioncontent: {
                    global_type: global_type,
                    func_type: func_type,
                    data: data,
                },
                closeWindow,
                needRefresh,
                needCallback,
            },
        },
        () => {
            console.log(global_type);
            callBack && callBack();
        }
    );
}

// 跳转APP登录，获取APP用户信息
export function loginApp() {
    return new Promise((resolve, reject) => {
        callNativePromise("MMCLogin", "", "cb_MMCLogin", () => {
            callNativePromise("getUserInfo", {}, "cb_getUserInfo").then(
                (userInfo: any) => {
                    let {
                        token,
                        platform,
                        deviceid,
                        channel,
                        userid,
                        version,
                    } = userInfo;
                    if (token && platform) {
                        localStorage.setItem("platform", platform);
                        store.commit("login/UPDATE_TOKEN", token);
                        store.commit("login/UPDATE_PLATFORM", platform);
                        store.commit("login/UPDATE_DEVICEID", deviceid);
                        store.commit("login/UPDATE_APPCHANNEL", channel);
                        store.commit("login/UPDATE_USERID", userid);
                        store.commit("login/UPDATE_VERSION", version);
                        resolve();
                    } else {
                        reject();
                    }
                }
            );
        });
    });
}

// 安卓游客模式判断是否登录
export function isAndroidVisitor() {
    return new Promise((resolve, reject) => {
        callNativePromise("getUserInfo", {}, "cb_getUserInfo").then(
            (userInfo: any) => {
                const { token = "" } = userInfo;
                if (!isIOS() && !token) {
                    resolve();
                } else {
                    reject();
                }
            }
        );
    });
}

// 判断某个DOM元素是否在屏幕可见区内
export const isElementInViewport = (el: any) => {
    try {
        let rect = el.getBoundingClientRect();
        return !(
            rect.top >=
                (window.innerHeight || document.documentElement.clientHeight) ||
            rect.bottom <= 0
        );
    } catch (error) {
        console.log(error);
    }
};

// 大额订单支付
export const largePay = async (order: any) => {
    return new Promise(function(resolve, reject) {
        if (!order) {
            resolve(true);
        }
        let {is_large_pay = false, large_url} = order;
        if (is_large_pay) {
            location.href = large_url;
            reject();
        } else {
            resolve(true);
        }
    })
}

// 根据订单号支付
export const payByOrderId = async (
    orderId: string = "",
    payType: string = "wechat"
) => {
    if (!orderId) {
        return;
    }

    const data = {
        order_id: orderId,
    };

    let {
        pay_url = "",
        alipay_pay_url = "",
        wechat_pay_url = "",
    }: any = await getPayUrlByOrderId(data);

    if (payType === "alipay") {
        location.href = alipay_pay_url;
    } else if (isWechat()) {
        location.href = wechat_pay_url;
    } else {
        location.href = pay_url;
    }
};

/**
 * 跳转到小程序原生通用支付页面
 * @param payParams 小程序的支付参数，https://developers.weixin.qq.com/miniprogram/dev/api/payment/wx.requestPayment.html
 * @param orderId
 * @param returnUrl 支付成功后重定向的链接
 */
export const jumpToMiniProgramUniversalPay = (payParams: string | object, orderId: string, returnUrl = '') => {
    // 如果传入的参数不是string的情况下，需要进行JSON.stringify
    const _payParams = typeof payParams === 'string' ? payParams : JSON.stringify(payParams);
    (window as any).wx.miniProgram.navigateTo({
        url: `/packageE/pages/pay/wxPay?payParams=${encodeURIComponent(
            _payParams,
        )}&orderId=${orderId}&return_url=${encodeURIComponent(returnUrl)}`,
    });
}

export function gotoGoodCoin({redirect = false} = {}) {
    let origin = isSandbox() ? 'https://sandbox-m.yiqiwen.cn' : 'https://m.yiqiwen.cn';
    if (isWxMiniprogram() && !isSandbox()) {
        origin = 'https://m.tianjinjingting.cn';
    }

    const path = '/dist2/good-coin'

    if (isWxMiniprogram()) {
        (window as any).wx.miniProgram[redirect ? 'redirectTo' : 'navigateTo']({
            url: `/pages/webview/webview?url=${origin}${path}&_mType=1`,
        });
        return;
    }

    const url = `${origin}${path}?mType=1`;
    if (redirect) {
        location.replace(url);
        return;
    }
    location.href = url;
}
export function gotoMMCclient(global_type, func_type, data) {
  (window as any).mmc.client.goto(
    {
      params: {
        action: 110,
        actioncontent: {
          global_type: global_type,
          func_type: func_type,
          data: data,
        },
        closeWindow: false,
        needRefresh: false,
      },
    }
  );
}

export async function openMiniProgramWebview(link, webviewParams = {}, { redirect = false } = {}) {

  const { url, query } = queryString.parseUrl(link);

  const mpQuery = {};
  Object.keys(query).forEach((key) => {
    mpQuery[`_${key}`] = query[key];
  });

  (window as any).wx.miniProgram[redirect ? 'redirectTo' : 'navigateTo']({
    url: queryString.stringifyUrl({
      url: `/pages/webview/webview`,
      query: {
        url,
        ...mpQuery,
        ...webviewParams,
      },
    }),
  });
}
